<template>
    <div>
        <div class="form-group" :class="wrapperClasses">
            <input
                class="input"
                :type="type"
                :class="textInputClasses"
                :autofocus="autofocus"
                :value="value"
                :name="name"
                :required="required"
                :placeholder="nativeLabel"
                :disabled="disabled"
                :pattern="pattern"
                :title="title"
                autocomplete="off"
                :tabindex="tabindex"
                :inputmode="inputmode"
                @input="$emit('input', $event.target.value)"
                @keydown.down="$emit('down')"
                @keydown.up="$emit('up')"
                @keydown.enter="$emit('enter')"
                @keydown.esc="$emit('esc')"
            >

            <label
                v-if="label"
                :for="`input-${name}`"
                class="floating-label"
            >
                {{ label }}
                <span
                    v-if="help"
                    class="text-xs italic"
                >
                    ({{ help }})
                </span>
            </label>

            <font-awesome-icon
                v-if="hasValidations && ! errors.has(name)"
                icon="check-circle"
            />
            <font-awesome-icon
                v-else-if="hasValidations"
                icon="exclamation-circle"
            />

            <font-awesome-icon
                v-if="icon"
                :icon="icon"
                :class="iconClasses"
                :size="iconSize"
                @click="$emit('clicked-icon')"
            />
        </div>

        <span v-if="hasValidations && errors.first(name)" class="h-md block">
            <span class="form-error">
                {{ errors.first(name) }}
            </span>
        </span>
    </div>
</template>

<script>
    export default {
        inheritAttrs: false,
        props: {
            type: {
                required: false,
                type: String,
                default: 'text',
            },
            value: {
                required: false,
                type: String,
                default: null,
            },
            name: {
                required: true,
                type: String,
                default: null,
            },
            nativeLabel: {
                required: false,
                type: String,
                default: ' ',
            },
            label: {
                required: false,
                type: String,
                default: '',
            },
            required: {
                required: false,
                type: Boolean,
                default: false,
            },
            autofocus: {
                required: false,
                type: Boolean,
                default: null,
            },
            icon: {
                required: false,
                type: [String, Array],
                default: null,
            },
            iconClasses: {
                required: false,
                type: String,
                default: null,
            },
            iconSize: {
                required: false,
                type: String,
                default: null,
            },
            iconPlacement: {
                required: false,
                type: String,
                default: null,
                validator(value) {
                    return ['left', 'right', ''].indexOf(value) !== -1;
                },
            },
            inputClasses: {
                required: false,
                type: Object,
                default: () => {
                    return {};
                },
            },
            disabled: {
                required: false,
                type: Boolean,
                default: false,
            },
            pattern: {
                required: false,
                type: String,
                default: null,
            },
            title: {
                required: false,
                type: String,
                default: null,
            },
            tabindex: {
                type: Number,
                required: false,
                default: null,
            },
            help: {
                type: String,
                required: false,
                default: null,
            },
            inputmode: {
                type: String,
                required: false,
                default: null,
            },
            formGroupClasses: {
                type: String,
                default: '',
            },
        },
        computed: {
            hasValidations() {
                return ! this.disabled && this.$attrs.validations;
            },
            wrapperClasses() {
                const classes = {
                    'form-group-floating-label': this.label,
                    'has-icon': this.icon,
                };

                if (this.formGroupClasses) {
                    classes[this.formGroupClasses] = true;
                }

                return classes;
            },
            iconPositionClasses() {
                const iconPosition = `has-icon-${this.iconPlacement}`;
                return {
                    [iconPosition]: this.icon,
                };
            },
            textInputClasses() {
                return {
                    ...this.iconPositionClasses,
                    ...this.inputClasses,
                };
            },
        },
    };
</script>
